import type { ReactNode } from 'react';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

interface MobileBackContextValue {
  backTo: string | null;
  setBackTo: (value: string | null) => void;
}

const MobileBackContext = createContext<MobileBackContextValue | null>(null);

export const MobileBackProvider = ({ children }: { children: ReactNode }) => {
  const [backTo, setBackTo] = useState<string | null>(null);
  const value = useMemo(() => ({ backTo, setBackTo }), [backTo]);

  return <MobileBackContext.Provider value={value}>{children}</MobileBackContext.Provider>;
};

/** Ruta na koju vodi strelica natrag u mobilnom headeru — null kad stranica nema BackButton. */
export const useMobileBackTo = () => useContext(MobileBackContext)?.backTo ?? null;

/** Registrira stranicu za strelicu natrag u mobilnom headeru; vraća false izvan AppLayouta. */
export const useRegisterMobileBack = (to: string) => {
  const ctx = useContext(MobileBackContext);
  const setBackTo = ctx?.setBackTo;

  useEffect(() => {
    if (!setBackTo) return;
    setBackTo(to);
    return () => setBackTo(null);
  }, [to, setBackTo]);

  return !!ctx;
};
